"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorCodes = exports.DisplayedErrorCodes = void 0;

var NoCertificates_1 = require("./NoCertificates");

Object.defineProperty(exports, "NoCertificates", {
  enumerable: true,
  get: function get() {
    return NoCertificates_1.NoCertificates;
  }
});

var NoCertificatesByFilter_1 = require("./NoCertificatesByFilter");

Object.defineProperty(exports, "NoCertificatesByFilter", {
  enumerable: true,
  get: function get() {
    return NoCertificatesByFilter_1.NoCertificatesByFilter;
  }
});

var BlockedTabModal_1 = require("./BlockedTabModal");

Object.defineProperty(exports, "BlockedTabModal", {
  enumerable: true,
  get: function get() {
    return BlockedTabModal_1.BlockedTabModal;
  }
});

var CARequestFailModal_1 = require("./CARequestFailModal");

Object.defineProperty(exports, "CARequestFail", {
  enumerable: true,
  get: function get() {
    return CARequestFailModal_1.CARequestFail;
  }
});

var NotTrustedHost_1 = require("./NotTrustedHost");

Object.defineProperty(exports, "NotTrustedHost", {
  enumerable: true,
  get: function get() {
    return NotTrustedHost_1.NotTrustedHost;
  }
});

var NoPlugin_1 = require("./NoPlugin");

Object.defineProperty(exports, "NoPlugin", {
  enumerable: true,
  get: function get() {
    return NoPlugin_1.NoPlugin;
  }
});

var NoSearchResults_1 = require("./NoSearchResults");

Object.defineProperty(exports, "NoSearchResults", {
  enumerable: true,
  get: function get() {
    return NoSearchResults_1.NoSearchResults;
  }
});

var UnsupportedBrowser_1 = require("./UnsupportedBrowser");

Object.defineProperty(exports, "UnsupportedBrowser", {
  enumerable: true,
  get: function get() {
    return UnsupportedBrowser_1.UnsupportedBrowser;
  }
});

var UnsupportedOS_1 = require("./UnsupportedOS");

Object.defineProperty(exports, "UnsupportedOS", {
  enumerable: true,
  get: function get() {
    return UnsupportedOS_1.UnsupportedOS;
  }
});

var NoCryptoPro_1 = require("./NoCryptoPro");

Object.defineProperty(exports, "NoCryptoPro", {
  enumerable: true,
  get: function get() {
    return NoCryptoPro_1.NoCryptoPro;
  }
});
var DisplayedErrorCodes;

(function (DisplayedErrorCodes) {
  DisplayedErrorCodes["NoPlugin"] = "NoPlugin";
  DisplayedErrorCodes["NotTrustedHost"] = "NotTrustedHost";
  DisplayedErrorCodes["NoCertificates"] = "NoCertificates";
  DisplayedErrorCodes["NoValidCertificates"] = "NoValidCertificates";
  DisplayedErrorCodes["NoActiveCertificates"] = "NoActiveCertificates";
  DisplayedErrorCodes["NoCertificatesByFilter"] = "NoCertificatesByFilter";
  DisplayedErrorCodes["UnsupportedBrowser"] = "UnsupportedBrowser";
  DisplayedErrorCodes["UnsupportedOS"] = "UnsupportedOS";
  DisplayedErrorCodes["DefaultCertificateListError"] = "DefaultCertificateListError";
  DisplayedErrorCodes["NoCryptoPro"] = "NoCryptoPro";
  DisplayedErrorCodes["ObsoletePluginVersion"] = "ObsoletePluginVersion";
})(DisplayedErrorCodes = exports.DisplayedErrorCodes || (exports.DisplayedErrorCodes = {}));

var ErrorCodes;

(function (ErrorCodes) {
  ErrorCodes["BlockedTabModal"] = "BlockedTabModal";
  ErrorCodes["CARequestFail"] = "CARequestFail";
  ErrorCodes["CertificateNotFound"] = "CertificateNotFound";
  ErrorCodes["CabucStatusMaxErrorCountExceeded"] = "CabucStatusMaxErrorCountExceeded";
  ErrorCodes["FailDoBeforeUpdateCertificate"] = "FailDoBeforeUpdateCertificate";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));